<template>
  <div class="container-fluid py-4">
    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-capsule fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Création d'un Médicament</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'liste_medicaments' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Nom -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Nom *</label>
          <input type="text" id="nom" v-model="medicament.nom" class="form-control form-control-clinique" :class="{ 'is-invalid': error.nom }" placeholder="Nom du médicament">
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Description -->
        <div class="col-md-12">
          <label for="description" class="form-label fw-semibold">Description</label>
          <textarea id="description" v-model="medicament.description" class="form-control form-control-clinique" rows="3" placeholder="Description facultative"></textarea>
        </div>

        <!-- Activé / Inactif -->
        <div class="col-md-6 d-flex align-items-center mt-3">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="isEnabled" v-model="medicament.isEnabled">
            <label class="form-check-label ms-2 fw-semibold" for="isEnabled">Activer le médicament</label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="saveMedicament">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      medicament: {
        nom: '',
        description: '',
        isEnabled: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      },
      error: { nom: '' }
    };
  },
  methods: {
    validateForm() {
      this.error.nom = this.medicament.nom ? '' : 'Le nom est requis';
      return !this.error.nom;
    },
    async saveMedicament() {
      if (!this.validateForm() || this.isLoading) return;

      this.isLoading = true;
      try {
        await api.createItem('medicaments', this.medicament);
        this.$router.push({ name: 'liste_medicaments' });
      } catch (error) {
        if (error.response && error.response.data) {
          const data = error.response.data;
          if (data.violations) {
            data.violations.forEach(v => {
              if (v.propertyPath === 'nom') this.error.nom = v.message;
            });
          } else if (data.detail && data.detail.includes('Duplicate entry')) {
            this.error.nom = 'Ce médicament existe déjà.';
          } else {
            alert('Une erreur est survenue lors de la création.');
            console.error(error);
          }
        } else {
          alert('Une erreur réseau est survenue.');
          console.error(error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_medicaments' });
    }
  }
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
